import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

i18n.use(ICU).use(ChainedBackend).use(LanguageDetector).use(initReactI18next);

export default i18n;
